<template>
  <div>
    <mobialis-nav-button
      v-av-analytics-cta-interaction="{ elementText: 'back', elementSubtype: 'nav_icon', eventActionResult: 'open' }"
      v-if="routeList.length > 1 && getNavButtonType === 'back'"
      @click.native="goBack"
      data-cy="backButton"
    >
      <img :src="require('@/assets/back-button.svg')" alt="back arrow" />
    </mobialis-nav-button>
    <mobialis-nav-button
      v-av-analytics-cta-interaction="{ elementText: 'home', elementSubtype: 'nav_icon', eventActionResult: 'open' }"
      v-else-if="showHome"
      @click.native="goHome"
      data-cy="homeButton"
    >
      <img :src="require('@/assets/home.svg')" alt="home image" />
    </mobialis-nav-button>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'NavButtonChanger',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getNavButtonType', 'getIsInitialized']),
    ...mapGetters({ getSpotlightHeroes: 'spotlight/getSpotlightHeroes' }),
    ...mapGetters({ isKijijiDealer: 'business/isKijijiDealer' }),
    showHome() {
      /**
       * We want to show the home button under two conditions:
       * 1. This component is specified to have a home button or,
       * 2. This is the first spotlight component the user has opened
       * (first load) from the dealership site AND it happens to be a hero spotlight.
       *
       * We determine if this is a first load or not by checking the route history to see
       * if it has a length of one; indicating that the user is on the first page after clicking
       * on our widget.
       *
       * We determine if this is a hero by matching the hero spotlights available to his business
       * with the current route name. If something matches, we can conclude that the current component
       * is a hero spotlight.
       *
       * We also want to disable the DHS if this is a kijiji integration or the RFA
       */
      return (
        (this.getNavButtonType === 'home' || (this.routeList.length === 1 && this.isHero())) &&
        this.getIsInitialized &&
        !this.hideAllHomeBtns
      );
    },
    ...mapState(['routeList']),
  },
  methods: {
    ...mapMutations(['SET_FIRST_LOAD_DONE']),
    goBack() {
      this.$store.dispatch('goBack', this.$router);
    },
    goHome() {
      this.$store.dispatch('goHome', { router: this.$router, homeRoute: this.homeRoute });
    },
    isHero() {
      if (this.getSpotlightHeroes) {
        const heroNames = this.getSpotlightHeroes.map(hero => hero.name);
        return heroNames.some(route => this.$route.path.includes(route));
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
